// src/components/sponsored-properties-carousel/sponsored-properties-carousel.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  query SponsoredPropertiesCarouselQuery($context: ContextInput!, $criteria: PropertySearchCriteriaInput, $shoppingContext: ShoppingContextInput) {\n    sponsoredPropertiesCarousel(context: $context, criteria: $criteria, shoppingContext: $shoppingContext) {\n      ...LodgingCarouselContainerFragment\n    }\n  }\n  ", "\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
import React2 from "react";
import LazyLoad from "react-lazy-load";
import { gql, useQuery } from "@apollo/client";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { LodgingCarouselContainer, ProductShoppingInvokeFunctionProvider } from "@shared-ui/lodging-fragments";
import { useLoggerEvents } from "@shared-ui/logger-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/utils/get-min-carousel-ads.ts
var breakpointsSizeMapping = {
  MOBILE_PHONE: "sm",
  APP_PHONE: "sm",
  MOBILE_TABLET: "md",
  APP_TABLET: "md",
  DESKTOP: "lg"
};
var getMinCarouselAdsSelection = function (device) {
  var itemsVisible = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    lg: 3,
    md: 2,
    sm: 1
  };
  return {
    id: "minCarouselAds",
    value: (itemsVisible[breakpointsSizeMapping[device]] + 1).toString()
  };
};
// src/utils/logger-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var EVENTS = {
  TRAVEL_AD_IMPRESSION_ERROR: new SystemEvent(SystemEventLevel.ERROR, "TRAVEL_AD_IMPRESSION_ERROR")
};
var ERROR_MESSAGES = {
  TRAVEL_AD_IMPRESSION_ERROR: "Error while firing travel ad impression"
};
// src/context/sponsored-properties-context.tsx
import React, { useMemo } from "react";
var SponsoredPropertiesState = {
  setIsProperties: function () {
    return void 0;
  },
  isProperties: false
};
var SponsoredPropertiesContext = React.createContext(SponsoredPropertiesState);
var useSponsoredPropertiesContext = function () {
  return React.useContext(SponsoredPropertiesContext);
};
var SponsoredPropertiesProvider = function (param) {
  var children = param.children;
  var _React_useState = _sliced_to_array(React.useState(false), 2),
    isProperties = _React_useState[0],
    setIsProperties = _React_useState[1];
  return /* @__PURE__ */React.createElement(SponsoredPropertiesContext.Provider, {
    value: useMemo(function () {
      return {
        isProperties: isProperties,
        setIsProperties: setIsProperties
      };
    }, [isProperties, setIsProperties])
  }, children);
};
// src/components/sponsored-properties-carousel/sponsored-properties-carousel.tsx
var __Query = gql(_templateObject(), LodgingCarouselContainer.fragment);
var SponsoredPropertiesCarousel = function (props) {
  var _inputs_criteria_secondary_selections, _inputs_criteria_secondary, _inputs_criteria;
  var skipSsr = props.skipSsr,
    itemsVisible = props.itemsVisible,
    onClickCallback = props.onClickCallback,
    onHoverChanged = props.onHoverChanged;
  var context = useBexApi().context;
  var setIsProperties = useSponsoredPropertiesContext().setIsProperties;
  var inputs = JSON.parse(JSON.stringify(props.inputs));
  (_inputs_criteria = inputs.criteria) === null || _inputs_criteria === void 0 ? void 0 : (_inputs_criteria_secondary = _inputs_criteria.secondary) === null || _inputs_criteria_secondary === void 0 ? void 0 : (_inputs_criteria_secondary_selections = _inputs_criteria_secondary.selections) === null || _inputs_criteria_secondary_selections === void 0 ? void 0 : _inputs_criteria_secondary_selections.push(getMinCarouselAdsSelection(context.device.type, itemsVisible));
  var logEvents = useLoggerEvents(EVENTS);
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr,
      fetchPolicy: "no-cache"
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var track = useClickTracker();
  var fireImpressionBeacon = React2.useCallback(function (index) {
    var _data_sponsoredPropertiesCarousel;
    var item = data === null || data === void 0 ? void 0 : (_data_sponsoredPropertiesCarousel = data.sponsoredPropertiesCarousel) === null || _data_sponsoredPropertiesCarousel === void 0 ? void 0 : _data_sponsoredPropertiesCarousel.items[index];
    if ((item === null || item === void 0 ? void 0 : item.__typename) === "LodgingCard") {
      var _item_impressionAnalytics;
      var impressionUrl = (_item_impressionAnalytics = item.impressionAnalytics) === null || _item_impressionAnalytics === void 0 ? void 0 : _item_impressionAnalytics.url;
      if (impressionUrl) {
        fetch(impressionUrl).catch(function (err) {
          logEvents.TRAVEL_AD_IMPRESSION_ERROR.log(JSON.stringify({
            message: ERROR_MESSAGES.TRAVEL_AD_IMPRESSION_ERROR,
            url: impressionUrl,
            error: err.message
          }));
        });
      }
    }
  }, [data]);
  var fireNextPrevNavEvent = React2.useCallback(function (direction) {
    var _data_sponsoredPropertiesCarousel_carousel_nextButton, _data_sponsoredPropertiesCarousel_carousel, _data_sponsoredPropertiesCarousel;
    var _ref = (data === null || data === void 0 ? void 0 : (_data_sponsoredPropertiesCarousel = data.sponsoredPropertiesCarousel) === null || _data_sponsoredPropertiesCarousel === void 0 ? void 0 : (_data_sponsoredPropertiesCarousel_carousel = _data_sponsoredPropertiesCarousel.carousel) === null || _data_sponsoredPropertiesCarousel_carousel === void 0 ? void 0 : (_data_sponsoredPropertiesCarousel_carousel_nextButton = _data_sponsoredPropertiesCarousel_carousel.nextButton) === null || _data_sponsoredPropertiesCarousel_carousel_nextButton === void 0 ? void 0 : _data_sponsoredPropertiesCarousel_carousel_nextButton.analytics) || {},
      referrerId = _ref.referrerId,
      linkName = _ref.linkName;
    if (referrerId && linkName) {
      track("".concat(referrerId, ".Carousel.scroll").concat(direction.charAt(0).toUpperCase() + direction.slice(1)), "".concat(linkName));
    }
  }, [data]);
  if (loading || error || !(data === null || data === void 0 ? void 0 : data.sponsoredPropertiesCarousel)) {
    return null;
  }
  setIsProperties(Boolean(data.sponsoredPropertiesCarousel.items));
  return /* @__PURE__ */React2.createElement(EGDSSpacing, {
    border: ["blockstart", "blockend"],
    padding: {
      block: "six"
    }
  }, /* @__PURE__ */React2.createElement("div", {
    "data-stid": "meso-similar-properties-carousel"
  }, /* @__PURE__ */React2.createElement(Viewport, null, /* @__PURE__ */React2.createElement(ViewSmall, null, /* @__PURE__ */React2.createElement(LazyLoad, {
    offset: 300
  }, /* @__PURE__ */React2.createElement(EGDSSpacing, {
    margin: {
      small: {
        inline: "three"
      },
      medium: {
        inline: "unset"
      }
    }
  }, /* @__PURE__ */React2.createElement("div", null, /* @__PURE__ */React2.createElement(ProductShoppingInvokeFunctionProvider, null, /* @__PURE__ */React2.createElement(LodgingCarouselContainer, {
    data: data.sponsoredPropertiesCarousel,
    peek: true,
    pageBy: 1,
    headingSize: 5,
    tag: "h4",
    margin: {
      blockstart: "three"
    },
    navigationIconId: {
      next: "similar-hotels-next",
      prev: "similar-hotels-prev"
    },
    fireCardsImpression: false,
    itemViewedCallback: fireImpressionBeacon,
    enableInlineLink: true,
    itemsVisible: itemsVisible,
    fireNextPrevNavEvent: fireNextPrevNavEvent,
    onClickCallback: onClickCallback,
    useContainerSizing: false,
    onHoverChanged: onHoverChanged
  })))))), /* @__PURE__ */React2.createElement(ViewMedium, null, /* @__PURE__ */React2.createElement(LazyLoad, {
    offset: 300
  }, /* @__PURE__ */React2.createElement(EGDSSpacing, {
    margin: {
      small: {
        inline: "three"
      },
      medium: {
        inline: "unset"
      }
    }
  }, /* @__PURE__ */React2.createElement("div", null, /* @__PURE__ */React2.createElement(ProductShoppingInvokeFunctionProvider, null, /* @__PURE__ */React2.createElement(LodgingCarouselContainer, {
    data: data.sponsoredPropertiesCarousel,
    peek: true,
    pageBy: 1,
    headingSize: 5,
    tag: "h4",
    margin: {
      blockstart: "three"
    },
    navigationIconId: {
      next: "similar-hotels-next",
      prev: "similar-hotels-prev"
    },
    fireCardsImpression: false,
    itemViewedCallback: fireImpressionBeacon,
    enableInlineLink: true,
    itemsVisible: itemsVisible,
    fireNextPrevNavEvent: fireNextPrevNavEvent,
    onClickCallback: onClickCallback,
    useContainerSizing: false,
    onHoverChanged: onHoverChanged
  })))))))));
};
SponsoredPropertiesCarousel.displayName = "sharedui-SponsoredPropertiesCarousel";
export { SponsoredPropertiesCarousel, SponsoredPropertiesProvider, useSponsoredPropertiesContext };